module.exports = {
  title: '培诺教育',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * 阿里云配置
   */
  aliyunConfig: {
    captcha: {
      region: 'cn',
      prefix: '1d1n4d',
      SceneId: '1xfzprgi'
    }
  }
}
